import { VarantwortungsArtData } from '@/types/service-response'
import { AddressFunction } from '@/model/addresses/AddressFunction'

export class ResponsibleEmployee {
  public constructor (
    readonly id: number | null,
    readonly shortName: string,
    readonly employeeId: number,
    readonly personalNumber: string,
    readonly functionLabel: string,
    readonly functionId: number | null,
    readonly employeeName: string,
    readonly farben: {Code: string | null, Farbe: string | null}[]
  ) {}

  public static createEmpty (): ResponsibleEmployee {
    return new ResponsibleEmployee(
      null,
      '',
      0,
      '',
      '',
      null,
      '',
      []
    )
  }

  public static Update (employee: ResponsibleEmployee, selectedEmployeeId: number, addressFunction: AddressFunction): ResponsibleEmployee {
    return new ResponsibleEmployee(
      employee.id,
      employee.shortName,
      selectedEmployeeId,
      employee.personalNumber,
      addressFunction.name,
      addressFunction.id,
      employee.employeeName,
      []
    )
  }

  public static createFromResponse (responseData: VarantwortungsArtData[]): Array<ResponsibleEmployee> {
    let result: Array<ResponsibleEmployee> = []
    if (responseData) {
      result = responseData.map((item: VarantwortungsArtData ) => {
        const farben: {Code: string | null, Farbe: string | null}[] = item.Farben.filter((i: {Code: string | null, Farbe: string | null}) => i.Code && i.Code.length > 0)
        return new ResponsibleEmployee(
          item.ID,
          item.Kurzzeichen ? item.Kurzzeichen : '',
          item.Mitarbeiter,
          item.Personalnummer ? item.Personalnummer : '',
          item.VarantwortungsArt ? item.VarantwortungsArt : '',
          item.VarantwortungsArtID,
          item.VollerName ? item.VollerName : '',
          farben
        )
      })
    }
    return result
  }
}
